export const validatePhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号不能为空'));
  } else {
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
    const invalidPhones = [];
    /** 支持逗号或者换行符号 */
    // 支持逗号或者换行符号隔开的手机号
    const phoneNumbers = value.split(/[,|\n]/);
    phoneNumbers.forEach(phone => {
      if (!reg.test(phone)) {
        invalidPhones.push(phone);
      }
    });

    if (invalidPhones.length > 0) {
      return callback(new Error(`手机号 ${invalidPhones.join(', ')} 不符合格式，请输入正确的手机号`));
    } else {
      // 验证通过，不带参数
      callback();
    }
  }
}
